import { useField } from "formik";

export default function HelpOrErrorMessage({ name, children, ...props }) {
    const [field, meta, helpers] = useField(name);
    return meta.error && meta.touched ? (
        <em className="error" {...props}>
            {meta.error}
        </em>
    ) : (
        <em className="help" {...props}>
            {children ? children : "\u00A0"}
        </em>
    );
}
